module.exports = __webpack_public_path__ + "img/wireframe.6bcaedb0.png";